/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className?: any;
}

export const ChartBreakoutSquare = ({
  className,
}: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16667 2.49996H6.5C5.09987 2.49996 4.3998 2.49996 3.86502 2.77244C3.39462 3.01213 3.01217 3.39458 2.77248 3.86498C2.5 4.39976 2.5 5.09983 2.5 6.49996V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.1349C3.01217 16.6053 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6053 17.2275 16.1349C17.5 15.6002 17.5 14.9001 17.5 13.5V10.8333M10 6.66663H13.3333V9.99996M12.9167 2.91663V1.66663M16.1995 3.80051L17.0833 2.91663M17.0919 7.08329H18.3419M2.5 11.1225C3.04328 11.2064 3.59989 11.25 4.16667 11.25C7.82197 11.25 11.0544 9.43962 13.0164 6.66663"
        stroke="url(#paint0_linear_2004_838)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.16667 2.49996H6.5C5.09987 2.49996 4.3998 2.49996 3.86502 2.77244C3.39462 3.01213 3.01217 3.39458 2.77248 3.86498C2.5 4.39976 2.5 5.09983 2.5 6.49996V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.1349C3.01217 16.6053 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6053 17.2275 16.1349C17.5 15.6002 17.5 14.9001 17.5 13.5V10.8333M10 6.66663H13.3333V9.99996M12.9167 2.91663V1.66663M16.1995 3.80051L17.0833 2.91663M17.0919 7.08329H18.3419M2.5 11.1225C3.04328 11.2064 3.59989 11.25 4.16667 11.25C7.82197 11.25 11.0544 9.43962 13.0164 6.66663"
        stroke="url(#paint2_linear_2004_838)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.16"
        strokeWidth="1.5"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2004_828"
          x1="-4.7363"
          x2="10.6409"
          y1="9.81138"
          y2="25.1968"
        >
          <stop stopColor="#7549F4" />
          <stop offset="1" stopColor="#FCA6E9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_2004_828"
          x1="10.4209"
          x2="10.4209"
          y1="1.66663"
          y2="17.5"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
